import _ from 'lodash';
import { APP_MODE } from '@/assets/js/config.js'
import { useAuthStore } from '@/stores/authStore';

export default () => {
	const appIsDemo = () => {
		return APP_MODE == 'demo';
	}
	const appVersion = () => {
		return window.localStorage.getItem('app_version');
	}
	const appCode = () => {
		return localStorage.getItem('app_code');
	}
	const isLogin = () => {
		let aUser = activeUser();
		if (_gHlp.isEmpty(aUser)) return false
		return true
	}
	const getActiveRemain = () => {
		let remaining = 0;
		if (isLogin()) {
			if (!_gHlp.isEmpty(window.localStorage.getItem('auth_token'))) {
				const tokenData = JSON.parse(window.localStorage.getItem('auth_token'))
				let exp_date = tokenData?.exp
				let now_date = Math.round(new Date().getTime() / 1000);
				if (exp_date > 0) remaining = exp_date - now_date;
			}
		}
		return remaining;
	}
	const isActiveSession = () => {
		let activeRemain = getActiveRemain();
		return activeRemain > 0;
	}
	const isAppSas = () => {
		return ((appCode()).toLowerCase()).includes('sas');
	}
	const isAppVps = () => {
		return ((appCode()).toLowerCase()).includes('vps');
	}
	const isAppHck = () => {
		return ((appCode()).toLowerCase()).includes('hck');
	}
	const isAppDahongye = () => {
		return ((appCode()).toLowerCase()).includes('dahongye');
	}
	const isAppConsfield = () => {
		return ((appCode()).toLowerCase()).includes('consfield');
	}
	const isCorporateOwner = () => {
		let aUser = activeUser();
		if (_gHlp.isEmpty(aUser)) return false;
		if (_gHlp.isEmpty(aUser.account_info)) return false;
		if (_gHlp.isEmpty(aUser.account_info.is_corporate_owner)) return false;

		return (aUser.account_info.is_corporate_owner == 1)
	}
	const isUseAdvisory = () => {
		let aUser = activeUser();
		if (_gHlp.isEmpty(aUser)) return null;

		return (!_gHlp.isEmpty(aUser.account_info)) ? aUser.account_info.is_use_advisory : null;
	}
	const isActvCorpIn = (ids) => {
		return ids.includes(activeCorporateId())
	}
	const activeUser = (attr = null, dflt = null) => {
		let local_auth_user = localStorage.getItem('auth_user');
		if (!_gHlp.isEmpty(local_auth_user)) {
			const usr = JSON.parse(local_auth_user);
			// IF NOT WANT RETURN VALUE SOME ATTRIBUTE RETURN ALL OBJECT
			if (_gHlp.isEmpty(attr)) return usr;
			// RETURN ATTRIBUTE VALUE
			return _gHlp.getValue(usr, attr, dflt);
		}
		return dflt;
	}
	const activeUserId = () => {
		let aUser = activeUser();
		if (_gHlp.isEmpty(aUser)) return null;
		return aUser.id;
	}
	const activeUserPublicCode = () => {
		let aUser = activeUser();
		if (_gHlp.isEmpty(aUser)) return null;
		return aUser.public_code;
	}
	const activeUserReferralLink = () => {
		let pcode = activeUserPublicCode();
		let code = (_gHlp.isEmpty(pcode)) ? '' : pcode;
		return window.location.hostname + '/new-agent-registration/' + code;
	}
	const activeMsgParticipant = () => {
		let local_data = localStorage.getItem('auth_msg_participant');
		if (!_gHlp.isEmpty(local_data)) {
			return JSON.parse(local_data);
		}
		return null;
	}
	const activeMsgParticipantId = () => {
		let local_data = activeMsgParticipant();
		if (_gHlp.isEmpty(local_data)) return null;
		return local_data.participant_id;
	}
	const activeCorporateId = () => {
		let aUser = activeUser();
		if (_gHlp.isEmpty(aUser)) return null;

		return (!_gHlp.isEmpty(aUser.account_info)) ? aUser.account_info.corporate_id : null;
	}
	const activeCorpSettings = (attr = null, dflt = null) => {
		let aUser = activeUser();
		if (_gHlp.isEmpty(aUser)) return null;
		if (_gHlp.isEmpty(attr)) return _gHlp.getValue(aUser,'account_info.corporate_settings',{});
		return _gHlp.getValue(aUser,'account_info.corporate_settings.'+attr,dflt)
	}
	const activeCorpIsUseLeadAutoAssignment = () => {
		let corpSetting = activeCorpSettings();
		return _gHlp.getValue(corpSetting,'is_lead_auto_assign',false)
	}
	const activeCorpIsMultiAssignment = () => {
		let corpSetting = activeCorpSettings();
		return activeCorpIsUseLeadAutoAssignment && _gHlp.getValue(corpSetting,'multi_assignment',false)
	}
	const activeCorpMsgGroupSuperAdminIds = () => {
		let corpSetting = activeCorpSettings();
		return _gHlp.getValue(corpSetting,'message_super_admin_ids',[])
	}
	const activeCorpMsgGroupDefaultAdminIds = () => {
		let corpSetting = activeCorpSettings();
		return _gHlp.getValue(corpSetting,'default_message_admin_ids',[])
	}
	const hasAccess = (modules) => {
		// return true;
		let aUser = activeUser();
		if (_gHlp.isEmpty(aUser) || _gHlp.isEmpty(aUser.access_codes)) return false;
		let intersect = _.intersection(aUser.access_codes, modules);
		return (intersect.length > 0);
	}
	const canAccess = async (to, from, next) => {
		/* CHECK CONTAIN ACCESS TOKEN */
		if (!_gHlp.isEmpty(to.query.auth)) {
			let data = JSON.parse(_gHlp.aesDecrypt(to.query.auth));
			console.log(data);
			if (!_gHlp.isEmpty(data.access_token) && !_gHlp.isEmpty(data.app_code)) {
				useAuthStore().saveToken(data.access_token, data.expires_in)
				let resp = await useAuthStore().fetchUserInfo(data.access_token);
				if (resp) {
					return 'Home';
				}
			}
		}
		/* CHECK HAS LOGIN */
		let stopInvLoop = ['login'];
		if (!isActiveSession() && !stopInvLoop.includes(to.name)) {
			// window.location.replace(configs.appUrl + '/login?r=' + to.path);
			return 'Login'
		}
		return '';
	}
	return {
		appIsDemo,
		isLogin,
		getActiveRemain,
		isActiveSession,
		appVersion,
		appCode,
		isAppSas,
		isAppVps,
		isAppHck,
		isAppDahongye,
		isAppConsfield,
		isUseAdvisory,
		isActvCorpIn,
		activeUser,
		activeUserId,
		activeUserPublicCode,
		activeUserReferralLink,
		activeCorpSettings,
		activeCorporateId,
		activeCorpIsUseLeadAutoAssignment,
		activeCorpIsMultiAssignment,
		activeCorpMsgGroupSuperAdminIds,
		activeCorpMsgGroupDefaultAdminIds,
		activeMsgParticipant,
		activeMsgParticipantId,
		isCorporateOwner,
		canAccess,
		hasAccess
	}
}
